export default {"src":"/login-app/[GIT_HASH]/_next/static/media/agent.c4463bfc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};